import type { Order } from "../../../../../../../services";
import type { TFunction } from "i18next";

const cellProcessing = (
	item: Order.Model["closedOrderComments"],
	t: TFunction,
): string => {
	const data = item?.[0];

	if (data?.dispatcher) return data.dispatcher.callSign || "";
	if (data?.executor) return data.executor.callSign || "";

	if (data?.customer) {
		return t("client") || "";
	}

	return "";
};

export default cellProcessing;
